import React from 'react';
import { useStyles } from './_utility';
import { useStore } from '../../zustand';
// import tipsIcon from '../../assets/icons/tipsIcon.png';
// import rotateIcon from '../../assets/icons/rotate.png';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
// import TextField from '@material-ui/core/TextField';
// import MenuItem from '@material-ui/core/MenuItem';
import clsx from 'clsx';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

// import Iframe from 'react-iframe'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ArActivation = () => {
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const variant_id = useStore(state => state.variant_id);
    const hrx = useStore.getState().hrx;
    const classes = useStyles(dynamic_text_settings);
    const [open, setOpen] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const actions = useStore(state => state.actions);

    const [values, setValues] = React.useState({
        offset: "",
    });

    const [measurement, setMeasurement] = React.useState('meters');

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleMeasurement = (event) => {
        setMeasurement(event.target.value);
    };

    const iconMeasurement = (type) => {
        switch(type) {
            case "feet":
                return 'ft'
            case "meters":
                return 'm'
            default:
                return ""
        }
    }

    const _handleLaunchAR = (e) => {
        e.preventDefault();
        setLoading(true);

        let urltoexport = `https://hank.levar.io/?variant=${variant_id}&yoffset=${values.offset}&intent=${hrx.intent}&measurementType=${measurement}&redirectBack=true`
        console.log('urltoexport', urltoexport)
        setTimeout(() => {  
            window.location.replace(urltoexport);
        }, 1000);
    };

    const handleClose = e => {
        setOpen(false)
        setTimeout(() => {
            actions.handleModalDisplay({ display: '', status: false })
        }, 750)
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="dispay-prompt"
            aria-describedby="dispay-prompt-modal"
            open={open}
            className={classes.root}
            TransitionComponent={Transition}
        >
            <section className={classes.modalTitleClose}>
                <h6>Custom Settings</h6>
                <IconButton aria-label="close" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </section>
            <MuiDialogContent dividers className={clsx(classes.root, classes.innerBody)}>
                <section className={classes.promptBody}>
                    <section className={classes.promptRow}>
                        <section className={classes.promptCopyBig}>
                            <p>To enhance your experience tell us how high off the ground you'd like the bottom of your fixture to hang</p>
                        </section>
                    </section>
                    <form className={classes.input_root} noValidate autoComplete="off">
                        <FormControl className={clsx(classes.margin, classes.textField, classes.formContainer)} variant="outlined">
                            <OutlinedInput
                                id="outlined-adornment-height"
                                value={values.height}
                                onChange={handleChange('offset')}
                                endAdornment={<InputAdornment position="end">{iconMeasurement(measurement)}</InputAdornment>}
                                aria-describedby="outlined-height-helper-text"
                                inputProps={{
                                    'aria-label': 'height',
                                }}
                                type="number"
                                className={classes.heightValue}
                                labelWidth={0}
                            />
                            <TextField
                                id="standard-select-height"
                                select
                                label="Choose Measurement"
                                value={measurement}
                                onChange={handleMeasurement}
                                variant="outlined"
                                className={classes.heightType}
                            >
                                <MenuItem value="meters">meters</MenuItem>
                                <MenuItem disabled value="feet">feet</MenuItem>
                            </TextField>
                        </FormControl>
                    </form>
                </section>
            </MuiDialogContent>
            <section className={classes.modalFooter}>
                <div className={classes.button_container_modal}>
                    <button 
                        onClick={(e) => _handleLaunchAR(e)} 
                        className={clsx({
                                [classes.btn_from_modal] : true,
                                [classes.btn_disabled] : values.offset.length <= 0 
                        })}
                    >
                        { !loading ? 'View in my space' : <div className={classes.loaderSpinner}></div> }
                    </button>
                </div>
            </section>
        </Dialog>
    );
}

export default ArActivation;